<template>
  <div class="card text-white text-left mb-5">
    <div class="maskot">
      <img src="~@/assets/img/maskot.png" class="maskot-img">
    </div>
    <div class="card-body monaco pt-5">
      <details>
        <summary><strong>Case 5: Atena Reader</strong></summary>
        <p>
          <br>
          <strong>Story</strong>: <br>
          Atena adalah sebuah mesin yang dibuat untuk membaca dan menulis file.
          Erwin salah seorang pengembang mesin ini. Namun Erwin baru saja memulai.
          Bantulah Erwin untuk membuat Atena agar dapat membaca <em>file</em>.
          <br><br>
          <strong>Ketentuan</strong>
          <ul>
            <li>Buat file yang bernama <em class="text-success">in</em></li>
            <li>
              Isikan daftar berikut kedalam file <em class="text-success">in</em>
              <pre>
                python
                javascript
                c#
                kotlin
                java
              </pre>
            </li>
            <li>Baca file <em>in</em> tersebut dengan program dan tampilkan dilayar.</li>
          </ul>
          <br><br>
          <strong>Contoh output</strong>: <br>
          <pre>
            python
            javascript
            c#
            kotlin
            java
          </pre>
        </p>
      </details>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      nama: '',
      kelas: '',
      jawaban: '',
      submited: false,
      sending: false,
    }
  },

  methods: {
    async submitAnswer() {
      this.sending = true
      let { data, error } = await this.$supabase
      .from('score2023')
      .insert([
        {
          email: this.email,
          nama: this.nama,
          kelas: this.kelas,
          jawaban: this.jawaban,
          case: 2
        }
      ])

      this.sending = false
      if (data) {
        this.submited = true
        this.email = ''
        this.nama = ''
        this.kelas = ''
        this.jawaban = ''
      }
    }
  }
};
</script>

<style scoped>
details {
  margin: 20px 0 20px 0;
}
pre {
  padding: 20px;
  padding-left: 0;
  padding-right: 0;
  color: #fff;
  background-color: #0b0b0b;
  border-top: 3px solid #fff;
  border-bottom: 3px solid #fff;
}
</style>
